export interface IPartnerUser {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    active: boolean;
    uuid: string;
    partnerUserUuid?: string;
}

export interface IUserSearchResult {
    userId: number;
    firstName: string;
    lastName: string;
    email: string;
    active: boolean;
    uuid: string;
    hasPushDevice: boolean;
}

export interface IPartnerUsersState {
    companyId: number | null;
    users: IPartnerUser[];
    loading: boolean;
    saving: boolean;
    error: string | null;
}
export const initialPartnerUsersState: IPartnerUsersState = {
    companyId: null,
    users: [],
    loading: false,
    saving: false,
    error: null,
};

export interface IUserSearchState {
    query: string;
    results: IUserSearchResult[];
    loading: boolean;
    error: string | null;
}

export const intiUserSearchState: IUserSearchState = {
    query: null,
    results: [],
    loading: false,
    error: null,
};
